import { useState } from "react";
import { Button, Stack, Typography } from "@mui/material";
import LifestyleFlyupModal from ".";
import { isAndroid, isIOS } from "@/utils";

export default function LifestyleFlyupModalExamples() {
  const [openDefault, setOpenDefault] = useState(false);
  const [openAndroid, setOpenAndroid] = useState(false);
  const [openIos, setOpenIos] = useState(false);

  console.log("isAndroid", isAndroid());
  console.log("isIOS", isIOS());

  return (
    <Stack spacing={4} p={2}>
      <Typography variant="h4" component="h2">
        LifestyleFlyupModal
      </Typography>

      <Stack direction="row" flexWrap="wrap" gap={2}>
        <Button
          variant="outlined"
          onClick={() => setOpenDefault(true)}
          aria-label="Open modal (device detection)"
        >
          Open (uses device detection)
        </Button>
        <Button
          variant="outlined"
          onClick={() => setOpenAndroid(true)}
          aria-label="Open as Android"
        >
          Open as Android (Health Connect section)
        </Button>
        <Button
          variant="outlined"
          onClick={() => setOpenIos(true)}
          aria-label="Open as iOS"
        >
          Open as iOS (no Android section)
        </Button>
      </Stack>

      <LifestyleFlyupModal
        isOpen={openDefault}
        onClose={() => setOpenDefault(false)}
        onConnect={() => {}}
      />
      <LifestyleFlyupModal
        isOpen={openAndroid}
        onClose={() => setOpenAndroid(false)}
        onConnect={() => {}}
        isButtonDisabled={true}
        showAndroidSection={true}
      />
      <LifestyleFlyupModal
        isOpen={openIos}
        onClose={() => setOpenIos(false)}
        onConnect={() => {}}
        isButtonDisabled={false}
      />
    </Stack>
  );
}
